import $ from 'jquery';
import { resizeFancybox } from '../utils';

export default class {

  constructor(el) {

    this.$el = el;
    this.searchParams;
    this.config = {
      afterShow: function (instance) {
        // Force resize after iframe is loaded
        // Every 200ms in the first second, then every 1s
        resizeFancybox(instance, 1, 200);
      },
      afterClose: () => history.replaceState({ key: Date.now() }, document.title, window.location.pathname),
    }

    // handle the modal on load
    this.handleModal()
    // handle modal when we click on the navigator arrows
    window.addEventListener('popstate', this.handleModal.bind(this));

    // Open the modal on click
    $("[data-fancybox]").fancybox({
      ...this.config,
      smallBtn: true,
      beforeShow: () => history.replaceState({ key: Date.now() }, document.title, '?modal=open'),
    });
  }

  /**
   * Show or hide modal if needed
   */
  handleModal() {
    const params = window.location.search;

    if (params) {
      this.searchParams = new URLSearchParams(params);
      const shouldBeOpend = this.searchParams.has('modal') && this.searchParams.get('modal') === 'open';

      // If params `modal` exist in URL and his value is `open` we open the modal
      shouldBeOpend && $.fancybox.open({
        src: this.$el.dataset.src,
        type: this.$el.dataset.type,
        opts: this.config,
      });

      return
    }

    $.fancybox.close();
  }
}



// WEBPACK FOOTER //
// ./scripts/components/Apply.js